"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
const testimonials = [{
  quote: "The level of sophistication Echelon Soiree brought to our gala was unparalleled. They are truly meticulous in every detail.",
  author: "Eleanor Vance",
  position: "Director of Philanthropy",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1582385/img/avatar_eleanor_vance.png"
}, {
  quote: "A masterclass in event design. They transformed a blank canvas into a cinematic experience for our brand launch.",
  author: "Julian Thorne",
  position: "Creative Lead, Aethelgard",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1582385/img/avatar_julian_thorne.png"
}];
export default function IndustryPraise() {
  return <section data-section-id="106987" id="whispered-praise" className="bg-background text-foreground relative flex min-h-[80vh] w-full items-center justify-center overflow-hidden py-24 sm:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center overflow-hidden select-none">
        <span className="text-secondary/30 font-serif text-[25vw] leading-none font-black tracking-tighter opacity-10">
          PRAISE
        </span>
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <Carousel opts={{
        align: "center",
        loop: true
      }} className="mx-auto w-full max-w-5xl">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                <div className="flex flex-col items-center justify-center space-y-12 px-4 text-center sm:px-12 md:px-24">
                  <blockquote className="text-foreground font-serif text-3xl leading-tight italic sm:text-4xl md:text-5xl lg:text-6xl tracking-tight">
                    &ldquo;{testimonial.quote}&rdquo;
                  </blockquote>

                  <div className="flex flex-col items-center space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4">
                    <SafeHydrate><Avatar className="border-border size-14 border sm:size-16 shadow-sm">
                      <AvatarImage src={testimonial.avatar} alt={testimonial.author} className="object-cover" />
                      <AvatarFallback className="bg-muted text-muted-foreground font-sans text-lg">
                        {testimonial.author.charAt(0)}
                      </AvatarFallback>
                    </Avatar></SafeHydrate>
                    <div className="text-center sm:text-left">
                      <div className="text-foreground font-sans text-lg font-medium tracking-normal">
                        {testimonial.author}
                      </div>
                      <div className="text-muted-foreground font-sans text-xs uppercase tracking-widest">
                        {testimonial.position}
                      </div>
                    </div>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          {}
          <div className="mt-16 flex items-center justify-center gap-4">
            <CarouselPrevious className="bg-background border-border hover:bg-primary hover:text-primary-foreground static translate-x-0 translate-y-0 shadow-sm transition-all duration-300" />
            <CarouselNext className="bg-background border-border hover:bg-primary hover:text-primary-foreground static translate-x-0 translate-y-0 shadow-sm transition-all duration-300" />
          </div>
        </Carousel>
      </div>
    </section>;
}